import { BenFn } from '@/common/BenFn'
import { BenHash } from './BenHash'
import { BenQuery } from './BenQuery'
import { BenView } from './BenView'

export class BenHeader {
  static init() {
    const $header = document.querySelector('[ben-js="header"]') as HTMLElement
    if (!$header) return
    _initMobileNavCtr()
    const $itemList = BenQuery.query('.nav > .item', { scope: $header })
    const $productList = $itemList.filter(($item) => $item.classList.contains('products'))
    const $normalItemList = $itemList.filter(($item) => $item.classList.contains('products') === false)
    $productList.forEach(($product) => {
      const $children = $product.querySelector(':scope > .children') as HTMLElement
      const $item2List = BenQuery.query(':scope > .item2', { scope: $children })
      const $children2List = BenQuery.query('.item2 > .children2', { scope: $product })
      _initPC({ $product, $children, $item2List, $children2List })
      _initMobile({ $product, $children, $item2List, $children2List })
    })
    $normalItemList.forEach(($item) => {
      const $childListWrap = $item.querySelector('.child-list') as HTMLElement | null
      if ($childListWrap === null) return
      _addEventToToggleActiveClassAndSlideChild($item, $childListWrap, 'mb-active')
    })
  }
}

function _initPC(params: { $product: HTMLElement; $children: HTMLElement; $item2List: HTMLElement[]; $children2List: HTMLElement[] }) {
  const { $product, $children, $item2List, $children2List } = params
  const me = 'me'
  const $firstItem2 = $item2List[0] || null
  let timerEnter = null as any
  let timerLeave = null as any
  let item2TimerObj = { timer: null as any }
  $product.addEventListener('mouseenter', () => {
    const isMobile = BenFn.isMobileByWidth(1001)
    if (isMobile) return
    clearTimeout(timerLeave)
    clearTimeout(timerEnter)
    timerEnter = setTimeout(() => {
      $product.classList.add(me)
      $firstItem2?.classList.add(me)
      let maxHeight = 0
      const childrenHeight = $children.clientHeight
      $children2List.forEach(($dom) => {
        const height = $dom.clientHeight
        if (maxHeight < height) maxHeight = height
      })
      if (maxHeight > childrenHeight) {
        $children.style.height = maxHeight + 'px'
      }
    }, 500)
  })
  $product.addEventListener('mouseleave', () => {
    const isMobile = BenFn.isMobileByWidth(1001)
    if (isMobile) return
    clearTimeout(timerEnter)
    clearTimeout(timerLeave)
    clearTimeout(item2TimerObj.timer)
    timerLeave = setTimeout(() => {
      $product.classList.remove(me)
      $item2List.forEach(($dom) => $dom.classList.remove(me))
    }, 100)
  })
  $item2List.forEach(($item2, index) => {
    _initItem2Event($item2List, item2TimerObj, $item2, index)
  })
}

function _initItem2Event($item2List: HTMLElement[], item2TimerObj: { timer: any }, $item2: HTMLElement, index: number) {
  const me = 'me'
  $item2.addEventListener('mouseenter', () => {
    const isMobile = BenFn.isMobileByWidth(1001)
    if (isMobile) return
    clearTimeout(item2TimerObj.timer)
    item2TimerObj.timer = setTimeout(() => {
      $item2List.forEach(($dom) => $dom.classList.remove(me))
      $item2.classList.add(me)
    }, 300)
  })
}

function _initMobileNavCtr() {
  const lockName = 'scroll-locked-nav'
  const header = document.querySelector('.g-header > .header') as HTMLElement
  if (!header) return
  const control = header.querySelector('.control')! as HTMLElement
  const $nav = header.querySelector(':scope > .nav')! as HTMLElement
  const hashKey = 'nav'
  control.addEventListener('click', () => {
    if (header.classList.contains('active')) {
      window.history.back()
    } else {
      BenView.setAction('nm')
      header.classList.add('active')
      document.documentElement.classList.add(lockName)
      BenHash.push(hashKey)
    }
  })
  $nav.addEventListener('mouseenter', () => {
    BenView.setAction('pm')
  })
  BenHash.onLeave(hashKey, () => {
    header.classList.remove('active')
    document.documentElement.classList.remove(lockName)
  })
}

function _initMobile(params: { $product: HTMLElement; $children: HTMLElement; $item2List: HTMLElement[]; $children2List: HTMLElement[] }) {
  const { $product, $children, $item2List, $children2List } = params
  const active = 'mb-active'
  _addEventToToggleActiveClassAndSlideChild($product, $children, active)
  const activeItem2Obj = { key: null as null | HTMLElement }
  $item2List.forEach(($item2) => {
    _initItem2MobileEvent($item2, activeItem2Obj)
  })
}

function _addEventToToggleActiveClassAndSlideChild($product: HTMLElement, $children: HTMLElement, active: string) {
  $product.addEventListener('click', () => {
    const isMobile = BenFn.isMobileByWidth(1001)
    if (!isMobile) return
    const isActive = $product.classList.contains(active)
    if (isActive) {
      BenQuery.slideUp($children)
      $product.classList.remove(active)
    } else {
      BenQuery.slideDown($children)
      $product.classList.add(active)
    }
  })
}

function _initItem2MobileEvent($item2: HTMLElement, activeItem2Obj) {
  const active = 'mb-active'
  $item2.addEventListener(
    'click',
    (e) => {
      e.stopPropagation()
      const isMobile = BenFn.isMobileByWidth(1001)
      if (!isMobile) return
      const isActive = $item2.classList.contains(active)
      const $children2 = $item2.querySelector('.children2') as HTMLElement | null
      if (!$children2) return
      if (!isActive) {
        e.preventDefault()
        BenQuery.slideDown($children2)
        $item2.classList.add(active)
        const $activeItem2 = activeItem2Obj.key
        if ($activeItem2 && $activeItem2 !== $item2) {
          $activeItem2.classList.remove(active)
          const $activeChildren2 = $activeItem2.querySelector('.children2') as HTMLElement | null
          if ($activeChildren2) BenQuery.slideUp($activeChildren2)
        }
        activeItem2Obj.key = $item2
      } else {
        if (e.target && e.target instanceof HTMLElement && e.target.classList.contains('mb-cover')) {
          BenQuery.slideUp($children2)
          $item2.classList.remove(active)
        }
      }
    },
    true,
  )
}
